// src/layouts/list-of/list-of.tsx
import Divider from "@a24/ui/Divider";
import Title from "@a24/ui/Title";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var ListOfColumn = (columnLists) => {
  return /* @__PURE__ */ jsx(Fragment, { children: columnLists.map((list, i) => {
    return /* @__PURE__ */ jsxs("div", { className: "pb-[3.75rem]", children: [
      /* @__PURE__ */ jsx(
        Title,
        {
          className: "body-xs uppercase pb-4",
          level: "h3",
          text: list.listTitle
        }
      ),
      list.listItems && /* @__PURE__ */ jsx("ul", { children: list.listItems?.map((listItem, i2) => {
        return /* @__PURE__ */ jsx(
          "li",
          {
            className: "heading-sm",
            children: listItem
          },
          `${i2}_${list.listTitle}_${listItem}`
        );
      }) })
    ] }, `${i}_${list.listTitle}`);
  }) });
};
var ListOf = ({
  className,
  first,
  fourth,
  id,
  second,
  third,
  title
}) => {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: `grid grid-cols-12 gap-x-3 ${className} max-md:px-6 max-2xl:px-16`,
      id,
      children: [
        /* @__PURE__ */ jsx("div", { className: "col-span-full row-span-1", children: title && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            Title,
            {
              className: "heading-lg pb-4 md:pb-6",
              level: "h2",
              text: title
            }
          ),
          /* @__PURE__ */ jsx(Divider, { className: "divider-default mb-10 md:mb-14" })
        ] }) }),
        first && /* @__PURE__ */ jsx("div", { className: "col-span-full row-span-1 sm:col-span-6 lg:col-span-3", children: ListOfColumn(first) }),
        second && /* @__PURE__ */ jsx("div", { className: "col-span-full row-span-1 sm:col-span-6 lg:col-span-3", children: ListOfColumn(second) }),
        third && /* @__PURE__ */ jsx("div", { className: "col-span-full row-span-1 sm:col-span-6 lg:col-span-3", children: ListOfColumn(third) }),
        fourth && /* @__PURE__ */ jsx("div", { className: "col-span-full row-span-1 sm:col-span-6 lg:col-span-3", children: ListOfColumn(fourth) })
      ]
    }
  );
};
var list_of_default = ListOf;

export {
  list_of_default
};
